// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Styles = require("@mui/material/styles");

var baseStyle_0 = Css.fontSize({
      NAME: "em",
      VAL: 3
    });

var baseStyle_1 = {
  hd: Css.width({
        NAME: "percent",
        VAL: 100
      }),
  tl: {
    hd: Css.borderTopWidth("zero"),
    tl: {
      hd: Css.borderLeftWidth("zero"),
      tl: {
        hd: Css.borderRightWidth("zero"),
        tl: {
          hd: Css.outlineStyle("none"),
          tl: {
            hd: Css.backgroundColor("transparent"),
            tl: /* [] */0
          }
        }
      }
    }
  }
};

var baseStyle = {
  hd: baseStyle_0,
  tl: baseStyle_1
};

var searchField = Css.style({
      hd: Css.borderBottomColor({
            NAME: "hex",
            VAL: "ffffff"
          }),
      tl: baseStyle
    });

var invalidSeachField = Css.style({
      hd: Css.borderBottomColor({
            NAME: "hex",
            VAL: "ff6961"
          }),
      tl: baseStyle
    });

var Styles$1 = {
  baseStyle: baseStyle,
  searchField: searchField,
  invalidSeachField: invalidSeachField
};

function Search(props) {
  var dispatch = props.dispatch;
  return JsxRuntime.jsx(Styles.ThemeProvider, {
              children: JsxRuntime.jsx("input", {
                    className: props.invalidSearch ? invalidSeachField : searchField,
                    autoFocus: true,
                    placeholder: "Search with PDG Number or Name",
                    type: "search",
                    onChange: (function (e) {
                        dispatch(e.target.value);
                      })
                  }),
              theme: Styles.createTheme({})
            });
}

var make = Search;

exports.Styles = Styles$1;
exports.make = make;
/* baseStyle Not a pure module */
